import { TechMeans, BaseRequest } from './common.interface';

export type ApiPutDisclosureSettingRequest = TechMeans & BaseRequest;

export const PutDisclosureSetting = Symbol('PutDisclosureSetting');

export interface PutDisclosureSetting {
    putDisclosureSetting(data: ApiPutDisclosureSettingRequest): Promise<void>;
}
